import script from "./edit-offers-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-offers-modal.vue?vue&type=script&setup=true&lang=ts"

import "./edit-offers-modal.vue?vue&type=style&index=0&id=140d0679&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-140d0679"]])

export default __exports__